export const SCHEDULE_TATKAL_PAGE_NAME = 'ScheduleTatakalTravelerPage';

export const SCHEDULE_TATKAL_REF_COMPONENTS = {
    COMPONENT_TRAVELER: 'traveler',
    COMPONENT_CONTACT_CARD: 'contact',
    COMPONENT_SCHEDULE_TATKAL_PAGE_SCROLL_VIEW: 'scheduleTatkalScrollView',
    COMPONENT_IRCTC_USERNAME: 'irctc_username',
    DUMMY_COMPONENT: 'dummy_component',
};

export const TATKAL_ALERT_STATUS = 'TATKAL alert';